<div class="d-flex flex-column gap-4">
  <div class="d-flex flex-column gap-2">
    <div class="file-list-label" i18n>Submitted Files</div>
    <div *ngIf="receivedDate" class="received-date" i18n>
      Document(s) received on {{ receivedDate | date : 'longDate' }}
    </div>
  </div>
  <div *ngIf="files?.length; else noFiles">
    <div class="d-flex flex-column gap-3">
      <app-file-list-item
        *ngFor="let file of files"
        [fileName]="file.attachment.fileName"
        [fileSizeInBytes]="file.attachment.fileSize"
        [previewUrl]="file.attachment.links | attachmentLink"
        action="download"
        class="w-100" />
    </div>
  </div>
</div>
<ng-template #noFiles>
  <div class="no-files" i18n>No submitted files.</div>
</ng-template>
